<div class="map-container" [class.unknown-location]="isUnknownLocation">
  <mat-progress-bar
    *ngIf="isLoadingHistoricalResults"
    mode="indeterminate"
    color="accent"
  ></mat-progress-bar>
  <ng-container *ngIf="organization; else noOrganization">
    <sn-google-map
      [class.penMode]="isModeActive('pen')"
      zoom="13"
      [center]="organization"
      (mapInit)="onMapInit($event)"
    >
      <!-- Search Map Area Button -->
      <div class="search-map-controls" *ngIf="drawingTools && !hideDrawings">
        <sn-flat-button
          color="accent"
          class="search-this-map-btn"
          [class.search-map-text]="!hasActiveShape || platesService.hasBoundarySearched"
          [matTooltip]="getSearchButtonTooltip()"
          (click)="onSearchMapAreaClick()"
          [disabled]="isSearchButtonDisabled()"
        >
          <sn-icon 
            [fontIcon]="hasActiveShape && !platesService.hasBoundarySearched ? 'fa-draw-square' : 'fa-map'" 
            fontSet="fal">
          </sn-icon>
          <span>{{ getSearchButtonText() }}</span>
        </sn-flat-button>
      </div>

      <!-- Drawing Tools -->
      <div class="drawingTools" *ngIf="drawingTools && !hideDrawings">
        <button
          *ngIf="!disableRectangle"
          [color]="isModeActive('rectangle') ? 'accent' : null"
          (click)="platesService.addShape('rectangle')"
          mat-icon-button
          [matTooltip]="'alpr.map.drawRectangle' | t"
        >
          <sn-icon fontIcon="fa-draw-square" fontSet="fal"></sn-icon>
        </button>
        <button
          color="warn"
          [disabled]="!platesService.activeShape"
          (click)="platesService.clearShape(undefined)"
          mat-icon-button
          [matTooltip]="'alpr.map.removeBoundary' | t"
        >
          <sn-icon fontIcon="fa-trash-alt" fontSet="fal"></sn-icon>
        </button>
      </div>
      <ng-content></ng-content>
    </sn-google-map>
  </ng-container>

  <!-- Add the unknown location overlay -->
  <div *ngIf="isUnknownLocation" class="unknown-location-overlay">
    <span>{{ 'alpr.map.unknownLocation' | t }}</span>
  </div>
</div>

<ng-template #noOrganization>
  <h2>{{ 'alpr.map.noOrganizationFound' | t }}</h2>
</ng-template>

<mat-menu #lprMenu xPosition="before" yPosition="above">
  <div class="makesGrid" (click)="$event.stopPropagation()">
    <div *ngFor="let lpr of platesService.makesArray">
      <mat-checkbox
        [checked]="selectMakes(lpr)"
        (click)="$event.stopPropagation()"
        (change)="updateLPRCameras($event, lpr)"
      >
        {{ lpr }}
      </mat-checkbox>
    </div>
  </div>
  <div class="gridActions">
    <button mat-button color="success" (click)="submitLPR()">{{ 'common.update' | t }}</button>
    <mat-checkbox
      [checked]="platesService.makesArray?.length === platesService.activeMakes?.length"
      (change)="selectAllMakes($event)"
      (click)="$event.stopPropagation()"
      >{{ 'common.selectAll' | t }}</mat-checkbox
    >
  </div>
</mat-menu>
